import React from 'react'

import { FAddressFragment } from '../graph/generated'
import { i18n } from '../i18n'

interface IProps {
  address: Maybe<FAddressFragment>
}

export const ShopAddress: React.FC<IProps> = ({ address }) => {
  if (!address || !address.location) {
    return <span>{i18n.t`Unknown address`}</span>
  }
  const { location } = address
  return (
    <span>{`${location.street} ${location.houseNumber},\n ${
      location.city
    }`}</span>
  )
}
